import React from 'react';
import { Link } from 'react-router-dom';

function formatCalendarDate(isoDate) {
  return new Date(`${isoDate}T12:00:00`).toLocaleDateString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
  });
}

const STATUS_STYLES = {
  red: 'bg-red-500/15 text-red-700 dark:text-red-300',
  amber: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  green: 'bg-green-500/15 text-green-700 dark:text-green-300',
};

export default function CalendarEventsTable({ events }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-gray-200">
            <th scope="col" className="py-2 pr-4 font-medium">Status</th>
            <th scope="col" className="py-2 pr-4 font-medium">Date</th>
            <th scope="col" className="py-2 pr-4 font-medium">App</th>
            <th scope="col" className="py-2 pr-4 font-medium">Event</th>
            <th scope="col" className="py-2 font-medium">Details</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => (
            <tr key={event.id} className="border-b border-gray-200 last:border-0">
              <td className="whitespace-nowrap py-2 pr-4">
                <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLES[event.statusTone] || 'bg-muted/40 text-muted'}`}>
                  {event.status}
                </span>
              </td>
              <td className="whitespace-nowrap py-2 pr-4">{formatCalendarDate(event.date)}</td>
              <td className="py-2 pr-4">
                {event.to ? <Link to={event.to} className="linkCls">{event.app}</Link> : event.app}
              </td>
              <td className="py-2 pr-4">{event.title}</td>
              <td className="py-2">{event.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
